<template>
  <div v-if="selectedPlan !== null && selectedPlan !== undefined">
    <archive-table
      icon="local_parking"
      calculationEntity="Premiums"
      :url="url()"
      identifier="premiumsArchive"
    ></archive-table>
  </div>
  <div v-else>
    <v-row justify="center">
      <v-progress-circular
        :size="70"
        :width="7"
        color="accent"
        indeterminate
      ></v-progress-circular>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ArchiveTable from "../components/ArchiveTable";
import { planSetter } from "../mixins/planSetter";

export default {
  name: "premiums-archive",
  components: {
    ArchiveTable
  },
  mixins: [planSetter],
  computed: {
    ...mapGetters("common", ["messages"]),
    ...mapGetters("common", { selectedPlan: "plan" }),
  },
  methods: {
    url() {
      return "plans/" + this.selectedPlan.Id + "/premiums";
    }
  }
};
</script>


